// Base error hierarchy
export abstract class AppError extends Error {
  public readonly kind: string;
  protected constructor(kind: string, message: string) {
    super(message);
    this.kind = kind;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class DomainError extends AppError {
  constructor(message: string) { super('domain', message); }
}
export class ValidationError extends AppError {
  constructor(message: string) { super('validation', message); }
}
export class NotAuthenticatedError extends AppError {
  constructor(message: string = 'Not authenticated') { super('auth', message); }
}
export class NotFoundError extends AppError {
  constructor(message: string) { super('not_found', message); }
}
export class TransportError extends AppError {
  status?: number;
  constructor(message: string, status?: number) {
    super('transport', message);
    this.status = status;
  }
}

export const isAppError = (e: unknown): e is AppError => e instanceof AppError;
